module.exports = __webpack_public_path__ + "static/media/color-white.41554e0a.svg";